var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHouseholdMeAndSomeoneElse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 22,
    viewBox: "0 0 31 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.55 0.500001C5.45 1 3.5 3.4 3.5 5.45C3.5 8.525 5.975 11 9.05 11C10.325 11 12.425 9.85 13.125 8.775C14.675 6.375 14.475 3.95 12.525 2C11.025 0.500001 9.5 0.0250006 7.55 0.500001Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.55 0.500001C17.45 1 15.5 3.4 15.5 5.45C15.5 8.525 17.975 11 21.05 11C22.325 11 24.425 9.85 25.125 8.775C26.675 6.375 26.475 3.95 24.525 2C23.025 0.500001 21.5 0.0250006 19.55 0.500001Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6746 12.4999C3.4746 13.3249 1.2496 15.8999 0.849604 19.2999C0.699604 20.4999 0.749604 20.7499 1.2246 21.2249C1.6996 21.6999 2.0246 21.7499 5.3996 21.7499H9.0496L8.8996 20.8999C8.6996 19.8249 9.2996 16.8999 9.9746 15.5249C10.2746 14.9749 10.8496 14.1249 11.2496 13.6499C11.9246 12.8999 11.9496 12.7749 11.5746 12.6249C10.8246 12.3249 7.6746 12.2499 6.6746 12.4999Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5993 12.5749C14.3493 13.4249 11.9243 16.2249 11.5743 19.5999C11.3493 21.7999 11.1243 21.7499 20.9243 21.7499C29.0493 21.7499 29.2743 21.7249 29.7743 21.2249C30.2243 20.7749 30.2743 20.5249 30.1243 19.5499C29.7243 16.6749 27.9243 14.2499 25.4493 13.1249C24.1243 12.5249 23.4743 12.3999 21.3743 12.3499C19.8743 12.2999 18.3493 12.3999 17.5993 12.5749Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseholdMeAndSomeoneElse);
export default __webpack_public_path__ + "static/media/household-me-and-someone-else.e89c506bbda45a96ad0d086b7e8ec9f5.svg";
export { ForwardRef as ReactComponent };